import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios
    .get(`${url}/purchases-delivery-items`, options)
    .then((response) => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta,
      };
    });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/purchases-delivery-items/${id}?include=`, options)
    .then((response) => {
      let purchasesdelivery = jsona.deserialize(response.data);
      delete purchasesdelivery.links;
      return purchasesdelivery;
    });
}

function add(purchasesdelivery) {
  const payload = jsona.serialize({
    stuff: purchasesdelivery,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/purchases-delivery-items?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(purchasesdelivery) {
  const payload = jsona.serialize({
    stuff: purchasesdelivery,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/purchases-delivery-items/${purchasesdelivery.id}?include=`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/purchases-delivery-items/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
